"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpecificitiesDefault = exports.useProductsDefault = exports.usePopover = exports.useFilterOptions = exports.useCategoriesDefault = exports.FILTER_OPTIONS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
var _queryString = _interopRequireDefault(require("query-string"));
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useProductsDefault = function useProductsDefault(params) {
  var location = (0, _reactRouterDom.useLocation)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useState = (0, _react.useState)(_queryString.default.parse(location.search)),
    _useState2 = _slicedToArray(_useState, 2),
    appliedFilter = _useState2[0],
    setAppliedFilter = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    history.push("".concat(location.pathname, "?").concat(_queryString.default.stringify(appliedFilter)));
    dispatch({
      type: "FETCH_PRODUCT_SALABLES",
      params: _objectSpread(_objectSpread({
        _embed: "category",
        _page: 1,
        _per_page: 10
      }, params), appliedFilter)
    });
  }, [appliedFilter]);
  return [appliedFilter, setAppliedFilter];
};
exports.useProductsDefault = useProductsDefault;
var useSpecificitiesDefault = function useSpecificitiesDefault(params) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch({
      type: "FETCH_SPECIFICITIES_OF_PRODUCT",
      params: params
    });
  }, []);
};
exports.useSpecificitiesDefault = useSpecificitiesDefault;
var useCategoriesDefault = function useCategoriesDefault(params) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch({
      type: "FETCH_CATEGORIES_OF_PRODUCT",
      params: _objectSpread({
        _fields: ["id", "name", "breadcrumb", "parent_category", "sub_categories"]
      }, params)
    });
  }, []);
};
exports.useCategoriesDefault = useCategoriesDefault;
var usePopover = function usePopover() {
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var handleOpen = function handleOpen(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  return {
    anchorEl: anchorEl,
    open: !!anchorEl,
    handleOpen: handleOpen,
    handleClose: handleClose
  };
};
exports.usePopover = usePopover;
var BASIC_OPERATIONS = [{
  id: "1",
  symbol: "",
  label: "est",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "est",
    defaultMessage: "est"
  })
}, {
  id: "2",
  symbol: "ne_",
  label: "n'est pas",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "n'est pas",
    defaultMessage: "n'est pas"
  })
}, {
  id: "3",
  symbol: "",
  label: "est nul",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "est nul",
    defaultMessage: "est nul"
  })
}, {
  id: "4",
  symbol: "ne_",
  label: "n'est pas nul",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "n'est pas nul",
    defaultMessage: "n'est pas nul"
  })
}];
var FILTER_OPTIONS = [{
  type: "string",
  options: [].concat(BASIC_OPERATIONS, [{
    id: "5",
    symbol: "like_",
    label: "contient",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "contient",
      defaultMessage: "contient"
    })
  }])
}, {
  type: "number",
  options: [].concat(BASIC_OPERATIONS, [{
    id: "5",
    symbol: "ge_",
    label: "est supérieur ou égal à",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "est sup\xE9rieur ou \xE9gal \xE0",
      defaultMessage: "est sup\xE9rieur ou \xE9gal \xE0"
    })
  }, {
    id: "6",
    symbol: "le_",
    label: "est inférieur ou égal à",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "est inf\xE9rieur ou \xE9gal \xE0",
      defaultMessage: "est inf\xE9rieur ou \xE9gal \xE0"
    })
  }])
}, {
  type: "date",
  options: [{
    id: "1",
    symbol: "ge_",
    label: "à partir de",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "\xE0 partir de",
      defaultMessage: "\xE0 partir de"
    })
  }, {
    id: "2",
    symbol: "le_",
    label: "jusqu'à",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "jusqu'\xE0",
      defaultMessage: "jusqu'\xE0"
    })
  }]
}, {
  type: "boolean",
  options: [].concat(BASIC_OPERATIONS),
  values: [{
    label: "Vrai",
    value: "true",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Vrai",
      defaultMessage: "Vrai"
    })
  }, {
    label: "Faux",
    value: "false",
    translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Faux",
      defaultMessage: "Faux"
    })
  }]
}, {
  type: "list",
  options: [].concat(BASIC_OPERATIONS)
}];
exports.FILTER_OPTIONS = FILTER_OPTIONS;
var useFilterOptions = function useFilterOptions(filterType) {
  var _useState5 = (0, _react.useState)(FILTER_OPTIONS.find(function (option) {
      return option.type === filterType;
    }).options[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    filterOption = _useState6[0],
    setFilterOption = _useState6[1];
  return {
    filterOption: filterOption,
    setFilterOption: setFilterOption
  };
};
exports.useFilterOptions = useFilterOptions;